import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from './services/loader.service';
import { Subscription } from 'rxjs';
import { SubscriptionService } from './services/subscription.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'AISSLO';
  loading: boolean = false;
  private loaderSubscription!: Subscription;

  constructor(
    private loaderService: LoaderService,
    private subscriptionService: SubscriptionService,
    private cdRef: ChangeDetectorRef
  ) {
    console.log('Environment:', environment);
  }

  ngOnInit() {
    this.loaderSubscription = this.loaderService.loading$.subscribe(
      (isLoading: boolean) => {
        this.loading = isLoading;

        // 🔑 Fix: Force Angular to notice the change in the right cycle
        this.cdRef.detectChanges();
      }
    );

    // Load subscription data
    this.subscriptionService.loadSubscription();
  }

  ngOnDestroy() {
    this.loaderSubscription.unsubscribe();
  }
}
